'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = arrayClean;

var _isEmpty = require('./isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Cleans the given array of _empty_ values
 *
 * @see {isEmpty} for how the values are determined to be empty.
 *
 * @param {Array} array The array to be _cleaned_
 * @returns {Array} The clean array
 *
 * @throws {TypeError} When the passed array is not actually an array.
 *
 * @example
 * const sourceArray = [undefined, null, true, '', {}];
 * arrayClean(sourceArray); // Returns: [true, {}]
 *
 * @example
 * arrayClean() // throws: Cannot read property 'length' of undefined
 */
// TODO: Could be written as `array.filter(isEmpty);`
function arrayClean(array) {
    var results = [],
        i = 0,
        ln = array.length,
        // TODO: throws if the error is undefined
    item;

    for (; i < ln; i++) {
        item = array[i];

        if (!(0, _isEmpty2.default)(item)) {
            results.push(item);
        }
    }

    return results;
}
//# sourceMappingURL=arrayClean.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2-utilizr/lib/arrayClean.js
// module id = 4
// module chunks = 0 1